import { capitalizeFirstLetter } from '../../utilities/services/capitalizeFirstLetter';
import './ApplicationsSummaryReminderItem.css';

export default function ApplicationsSummaryReminderItem({reminderItem}) {
  return (
    <div className='ApplicationsSummaryReminderItem'>
        <div className='title'>
            <span><strong>{reminderItem.RPNumber}</strong>&nbsp;</span>
            <span>(<i>{capitalizeFirstLetter(reminderItem.applicationType)}</i>)</span>
        </div>
        <div className='message'>
            <span><strong>{reminderItem.message}</strong>&nbsp;</span>
            <span className='condition'>[Sent {reminderItem.numberOfDays} day{reminderItem.numberOfDays!==1? 's':''} {reminderItem.beforeOrAfter} {reminderItem.fieldOfInterest}]</span>
        </div>
        <div className='sentDaysCount'>
            <span>{reminderItem.sentDaysCount} day{reminderItem.sentDaysCount!==1? 's':''} ago</span>
        </div>
    </div>
  )
}
